"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPINNER_DEFAULT_SIZE = exports.PX_TO_REM = exports.PADDING_FACTOR = exports.BORDER_RADIUS_FACTOR = exports.QR_DEFAULT_SIZE = exports.QR_MAX_SIZE = exports.QR_MIN_SIZE = void 0;
var QR_MIN_SIZE = 30;
exports.QR_MIN_SIZE = QR_MIN_SIZE;
var QR_MAX_SIZE = 547;
exports.QR_MAX_SIZE = QR_MAX_SIZE;
var QR_DEFAULT_SIZE = 130;
exports.QR_DEFAULT_SIZE = QR_DEFAULT_SIZE;
var BORDER_RADIUS_FACTOR = 13;
exports.BORDER_RADIUS_FACTOR = BORDER_RADIUS_FACTOR;
var PADDING_FACTOR = 5.8;
exports.PADDING_FACTOR = PADDING_FACTOR;
var PX_TO_REM = 16;
exports.PX_TO_REM = PX_TO_REM;
var SPINNER_DEFAULT_SIZE = '3rem';
exports.SPINNER_DEFAULT_SIZE = SPINNER_DEFAULT_SIZE;